import React, { useEffect, useState } from "react";
import { Table, Input, Button, Popconfirm, Form, Col, Row, Space } from "antd";
import moment from "moment";
import {
  DownCircleOutlined,
  PlusOutlined,
  UpCircleOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as EditIcon } from "../../../../assets/edit-icon.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/delete-icon.svg";
import { ReactComponent as CrossIcon } from "../../../../assets/crossIcon.svg";
import { ReactComponent as SaveIcon } from "../../../../assets/save-icon.svg";
import { ReactComponent as AttachIcon } from "../../../../assets/attach.svg";
import * as actions from "./redux/actions";
import SpinnerComponent from "../../../../components/spinner";
import NonEditRowAttach from "./nonEditRowAttachView";
import CustomCalendar from "../../../../components/calendar";
import RevisionsEditableCell from "./revisionsEditableCell";
// import AMultiSelect from "../../../../components/AMultiSelect";
import _ from "lodash";
import UseImsPermission from "../../useImsPermissions";

function DistributionsTable({ parentRecordID, doc_distributions }) {
  const [data, setData] = useState([]);
  const [editingKey, setEditingKey] = useState("");
  const [sortedInfo, setSortedInfo] = useState(null);
  const [editingLoading, setEditingLoading] = useState(false);
  const [currentUpdateObj, setCurrentUpdateObj] = useState({});
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [images, setImages] = useState([]);
  // images contains all attachments of item
  const [attachPopupVisible, setAttachPopupVisible] = useState(false);
  const [search, setSearch] = useState({});
  const [date, setDate] = useState(null);
  // const [activitiesCheckedList, setActivitiesCheckedList] = useState([]);
  // const [salesRepCheckedList, setSalesRepCheckedList] = useState([]);
  const [deletingActivityId, setDeleteActivityId] = useState();
  const [showTable, setShowTable] = useState(false);
  const [req, setReq] = useState(false);
  const [, canEdit, , canDelete] = UseImsPermission();

  const isEditing = (record) =>
    record.key === editingKey || record.id === editingKey;

  const {
    allImsDistributions,
    fetchingLoading,
    updateLoading,
    isAddImsDistribution,
    isUpdateImsDistribution,
    deletingLoading,
  } = useSelector((state) => state.imsDistributionReducer);

  const { user } = useSelector((state) => state.authReducer);

  const handleUpdateStatus = (isAdd, isUpdate) => {
    dispatch(
      actions.updateImsDistributionIsAddIsUpdate({
        isAddImsDistribution: isAdd,
        isUpdateImsDistribution: isUpdate,
      })
    );
  };

  useEffect(() => {
    let order = sortedInfo?.order === "ascend" ? "asc" : "desc";
    if (doc_distributions.length > 0) {
      let distribution_id = doc_distributions.map((rev) => rev.id);
      let sort = sortedInfo?.order && sortedInfo?.columnKey;
      let orderParam = sortedInfo?.order ? order : null;

      dispatch(
        actions.fetchImsDistribution({
          id: parentRecordID,
          search: { ...search, distribution_id },
          sort,
          order: orderParam,
        })
      );
    } else {
      dispatch(actions.fetchImsDistributionSuccess([]));
    }
  }, [req]);

  useEffect(() => {
    debouncedCallApi();
  }, [sortedInfo]);

  const [debouncedCallApi] = useState(() =>
    _.debounce(() => setReq((prev) => !prev), 1000)
  );

  useEffect(() => {
    setEditingLoading(updateLoading);
    if (!updateLoading) {
      setEditingKey("");
    }

    return () => {
      handleUpdateStatus(false, false);
    };
  }, [updateLoading]);

  useEffect(() => {
    if (allImsDistributions.length === 0) {
      return setData(allImsDistributions);
    } else if (allImsDistributions.length > 0) {
      let updatedData = allImsDistributions.map((el) => {
        const { distribution_attachments, ...rest } = el;

        let updatedImages;
        if (distribution_attachments?.length > 0) {
          updatedImages = distribution_attachments.map((img) => {
            const { url, id } = img;
            let name = url.split("/")[url.split("/").length - 1].split("?")[0];

            return { key: id, id, image: url, isLocal: false, name };
          });
        }

        return { ...rest, images: updatedImages };
      });
      setData(updatedData);
    }
  }, [allImsDistributions]);

  const edit = (record) => {
    const { isAdd } = record;
    if (!isAdd) {
      setCurrentUpdateObj(record);
      let filteredItems = data.filter((el) => el.id !== editingKey);
      let final = filteredItems.filter((el) => el.key !== editingKey);
      setData(final);
      setImages(record?.images || []);
    }
    const { distribution_date } = record;
    form.setFieldsValue({
      ...record,
      distribution_date: moment(distribution_date),
      username: record?.user?.first_name + " " + record?.user?.surname,
    });
    !isAdd && handleUpdateStatus(false, true);
    setEditingKey(record.id);
  };

  const cancel = () => {
    if (isUpdateImsDistribution) {
      setData(data);
    } else {
      // if (editingKey) {
      let filteredItems = data.filter((el) => el.id !== editingKey);
      let final = filteredItems.filter((el) => el.key !== editingKey);
      setData(final);
      // }
    }
    handleUpdateStatus(false, false);
    setEditingKey("");
  };

  const save = async (key) => {
    setEditingKey(key);
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex(
        (item) => key === item.key || key === item.id
      );
      if (index > -1) {
        form.submit();
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const searchInput = (key, placeholder) => (
    <Input
      placeholder={""}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => {
        setSearch({
          ...search,
          [key]: e.target.value,
        });
        debouncedCallApi();
      }}
    />
  );

  const handleDateInput = (value) => {
    setDate(value);
    if (value === null) {
      setSearch({
        ...search,
        distribution_start_date: "",
        distribution_end_date: "",
      });
    } else {
      setSearch({
        ...search,
        distribution_start_date: value[0],
        distribution_end_date: value[1],
      });
    }
    debouncedCallApi();
  };

  const handleMultiSelect = (list, key) => {
    setSearch({
      ...search,
      [key]: list,
    });
    // debouncedCallApi();
  };

  const handleSelectOnchange = (value, options, key, setHandler) => {
    if (value.includes("all")) {
      setHandler([...options.map((item) => item.value)]);
      value = options.map((item) => item.value);
    } else if (value.includes("not-all")) {
      setHandler([]);
      value = [];
    } else {
      setHandler(value);
    }
    handleMultiSelect(value, key);
  };

  const onDeleteSuccess = () => {
    setDeleteActivityId();
    debouncedCallApi();
  };

  const deleteDistributionHandler = (record) => {
    setDeleteActivityId(record.id);
    dispatch(
      actions.deleteImsDistribution({
        ...record,
        onDeleteSuccess,
        parentRecordID,
      })
    );
  };

  const columns = [
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">Date</div>
            <div>
              <CustomCalendar
                date={date}
                setDate={setDate}
                format={"D MMM YYYY"}
                handleDateInput={handleDateInput}
              />
            </div>
          </div>
        );
      },
      dataIndex: "distribution_date",
      key: "distribution_date",
      sorter: true,
      sortOrder:
        sortedInfo?.columnKey === "distribution_date" && sortedInfo?.order,
      width: 240, // "8%"
      editable: true,
      render: (date) => {
        return moment(date).format("DD MMMM YYYY");
      },
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">User</div>
            <div>{searchInput("username")}</div>
          </div>
        );
      },
      dataIndex: "username",
      key: "username",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "username" && sortedInfo?.order,
      width: 150,
      editable: true,
      render: (username, record) => {
        // const { first_name, surname } = user;
        return record?.user?.first_name + " " + record?.user?.surname;
      },
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">rev</div>
            <div>{searchInput("rev")}</div>
          </div>
        );
      },
      dataIndex: "rev",
      key: "rev",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "rev" && sortedInfo?.order,
      width: 70,
      align: "center",
      editable: true,
      render: (rev) => <div>{rev}</div>,
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">ISSUED BY</div>
            <div>{searchInput("issued_by")}</div>
          </div>
        );
      },
      dataIndex: "issued_by",
      key: "issued_by",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "issued_by" && sortedInfo?.order,
      width: 150,
      align: "center",
      editable: true,
      render: (issued_by) => <div>{issued_by}</div>,
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">ISSUED TO</div>
            <div>{searchInput("issued_to")}</div>
          </div>
        );
      },
      dataIndex: "issued_to",
      key: "issued_to",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "issued_to" && sortedInfo?.order,
      width: 150,
      align: "center",
      editable: true,
      render: (issued_to) => <div>{issued_to}</div>,
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">
              NO OF <br /> COPIES
            </div>
            <div>{searchInput("no_of_copies")}</div>
          </div>
        );
      },
      dataIndex: "no_of_copies",
      key: "no_of_copies",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "no_of_copies" && sortedInfo?.order,
      width: 70,
      align: "center",
      editable: true,
      render: (no_of_copies) => <div>{no_of_copies}</div>,
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">copies size</div>
            <div>{searchInput("copy_size")}</div>
          </div>
        );
      },
      dataIndex: "copy_size",
      key: "copy_size",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "copy_size" && sortedInfo?.order,
      width: 120,
      align: "center",
      editable: true,
      render: (copy_size) => <div>{copy_size}</div>,
    },
    // {
    //   title: () => {
    //     return (
    //       <div align="top" className="select-parent-div">
    //         <div className="special-table-header-text">status</div>
    //         <div>
    //           {searchInput("status", "")}
    //           {/* <AMultiSelect
    //             debouncedCallApi={debouncedDefaultPageOneCallApi}
    //             dropdownClassName="status-selector"
    //             disabled={false}
    //             placeholder=""
    //             selectTags={statusCheckList}
    //             onSelectChange={(value) =>
    //               handleSelectOnchange(
    //                 value,
    //                 statusOptions,
    //                 "document_status_id",
    //                 setStatusCheckList
    //               )
    //             }
    //             data={getOptions(statusOptions, statusCheckList) || []}
    //             filterOption={(input, option) => {
    //               return (
    //                 option?.label?.toLowerCase().indexOf(input.toLowerCase()) >=
    //                 0
    //               );
    //             }}
    //           /> */}
    //         </div>
    //       </div>
    //     );
    //   },
    //   dataIndex: "revision_status_id",
    //   key: "revision_status_id",
    //   sorter: true,
    //   sortOrder:
    //     sortedInfo?.columnKey === "revision_status_id" && sortedInfo?.order,
    //   width: 120,
    //   editable: true,
    //   render: (id, record) => {
    //     if (!Boolean(record?.revision_status)) {
    //       return;
    //     }

    //     const { revision_status } = record;
    //     const { color, status_name } = revision_status;
    //     return (
    //       <Tag color={color} className="doc-status-tag">
    //         {status_name}
    //       </Tag>
    //     );
    //   },
    // },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">TRANSMITTAL NUMBER</div>
            <div>{searchInput("transmittal_no")}</div>
          </div>
        );
      },
      dataIndex: "transmittal_no",
      key: "transmittal_no",
      sorter: true,
      sortOrder:
        sortedInfo?.columnKey === "transmittal_no" && sortedInfo?.order,
      width: 160,
      align: "center",
      editable: true,
      render: (transmittal_no) => <div>{transmittal_no}</div>,
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">
              <div>
                <div>Attach</div>
                <div style={{ color: "transparent" }}>_</div>
              </div>
            </div>
          </div>
        );
      },
      dataIndex: "images",
      key: "images",
      sorter: false,
      sortOrder: sortedInfo?.columnKey === "images" && sortedInfo?.order,
      width: 70,
      editable: true,
      align: "center",
      render: (_, record) => {
        if (currentUpdateObj.id !== record.id) {
          return (
            <div
              className={`attach-parent-div  ${
                (isAddImsDistribution || isUpdateImsDistribution) &&
                "disable-icon"
              }`}
              onClick={() => {
                if (isAddImsDistribution || isUpdateImsDistribution) {
                  return;
                } else {
                  setCurrentUpdateObj(record);
                  setAttachPopupVisible(true);
                }
              }}
            >
              <AttachIcon
                className="rotate-icon activities-attach"
                width={16}
                fill="#231f20"
              />
              <div>{record?.images?.length || 0}</div>
            </div>
          );
        }

        return (
          <NonEditRowAttach
            images={record?.images || []}
            setImages={setImages}
            attachPopupVisible={attachPopupVisible}
            setAttachPopupVisible={setAttachPopupVisible}
            record={record}
            setCurrentUpdateObj={setCurrentUpdateObj}
            currentUpdateObj={currentUpdateObj}
            parentRecordID={parentRecordID}
          />
        );
      },
    },
    {
      title: "",
      dataIndex: "operation",
      align: "center",
      width: 80,
      render: (_, record) => {
        const editable = isEditing(record);
        let key = record?.key || record?.id;
        return editable ? (
          editingLoading && editingKey === key ? (
            <SpinnerComponent fontSize={14} />
          ) : (
            <Space size={20} align="center">
              <Popconfirm
                getPopupContainer={() =>
                  document.getElementsByClassName(
                    "ant-layout-content layout-content site-layout-background custom-textarea"
                  )[0]
                }
                placement="rightTop"
                overlayClassName="activities-popconfirm"
                title="Are you sure you want to save this Distribution?"
                onConfirm={() => save(record.key || record.id)}
                okText="Yes"
                cancelText="No"
              >
                <SaveIcon className="custom-icon" />
              </Popconfirm>
              {/* {!isUpdateImsDistribution && ( */}
              <Popconfirm
                getPopupContainer={() =>
                  document.getElementsByClassName(
                    "ant-layout-content layout-content site-layout-background custom-textarea"
                  )[0]
                }
                title="Sure to cancel?"
                onConfirm={cancel}
              >
                <CrossIcon
                  className="custom-icon"
                  style={{
                    height: "20px",
                    width: "20px",
                  }}
                />
              </Popconfirm>
              {/* // )} */}
            </Space>
          )
        ) : (
          <div>
            <Space size={20} align="center">
              {deletingLoading && record.id === deletingActivityId ? (
                <SpinnerComponent fontSize={16} />
              ) : (
                <>
                  {canEdit && (
                    <EditIcon
                      className={`custom-icon ${
                        (isAddImsDistribution || isUpdateImsDistribution) &&
                        "disable-icon"
                      }`}
                      disabled={editingKey !== ""}
                      onClick={() =>
                        !isAddImsDistribution &&
                        !isUpdateImsDistribution &&
                        edit({ ...record, isAdd: false })
                      }
                    />
                  )}
                  {!isAddImsDistribution && !isUpdateImsDistribution ? (
                    canDelete && (
                      <Popconfirm
                        getPopupContainer={() =>
                          document.getElementsByClassName(
                            "ant-layout-content layout-content site-layout-background custom-textarea"
                          )[0]
                        }
                        placement="rightTop"
                        title="Are you sure you want to delete this Distribution?"
                        onConfirm={() => deleteDistributionHandler(record)}
                      >
                        <DeleteIcon className={`custom-icon`} />
                      </Popconfirm>
                    )
                  ) : (
                    <DeleteIcon
                      className={`custom-icon ${
                        (isAddImsDistribution || isUpdateImsDistribution) &&
                        "disable-icon"
                      }`}
                    />
                  )}
                </>
              )}
            </Space>
          </div>
        );
      },
    },
  ];

  const handleAdd = () => {
    setShowTable(true);
    setSortedInfo(null);
    handleUpdateStatus(true, false);
    setCurrentUpdateObj({});
    let key = Math.ceil(Math.random() * 2345678);
    const newData = {
      key,
      id: key,
      distribution_date: moment(),
      username: user?.first_name + " " + user?.surname,
      rev: null,
      issued_by: null,
      issued_to: null,
      no_of_copies: null,
      copy_size: null,
      transmittal_no: null,
      comment: null,
      revision_status_id: null,
      images: null,
      isAdd: true,
    };
    setData((data) => [newData, ...data]);
    // setCount(1);
    edit(newData);
    setImages([]);
    form.setFieldsValue({
      ...newData,
    });

    setEditingKey(key);
  };

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => {
        return {
          record,
          // inputType:,
          dataIndex: col.dataIndex,
          title: col.title,
          editing: isEditing(record),
        };
      },
    };
  });

  const hanldeFinish = (item) => {
    const { distribution_date } = item;
    if (isUpdateImsDistribution) {
      dispatch(
        actions.updateImsDistribution({
          ...item,
          distribution_date: moment(distribution_date),
          id: currentUpdateObj.id,
          ...(images.length > 0 && { images }),
          parentRecordID,
          user_id: user.id,
          debouncedCallApi,
        })
      );
    } else {
      dispatch(
        actions.createImsDistribution({
          ...item,
          distribution_date: moment(distribution_date),
          ...(images.length > 0 && { images }),
          parentRecordID,
          user_id: user.id,
          debouncedCallApi,
        })
      );
    }
  };

  const handleChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
  };

  return (
    <Row className="revisions-parent-row">
      <Col span={24} className="heading-col">
        <Row align="middle">
          <Col>
            <div className="revisions-heading-div">
              <div onClick={() => setShowTable(!showTable)}>
                {showTable ? (
                  <UpCircleOutlined className="revision-up-down-icon" />
                ) : (
                  <DownCircleOutlined className="revision-up-down-icon" />
                )}
              </div>
              <div>
                <span
                  className="heading-span"
                  style={{
                    cursor: "text",
                  }}
                >
                  DISTRIBUTION{" "}
                  {allImsDistributions.length > 0 &&
                    `(${allImsDistributions.length})`}
                </span>
              </div>
            </div>
          </Col>
          {canEdit && (
            <Col>
              <Button
                icon={<PlusOutlined />}
                className="add-revisions-btn"
                size="small"
                onClick={handleAdd}
                disabled={
                  isAddImsDistribution ||
                  fetchingLoading ||
                  isUpdateImsDistribution
                }
              >
                DISTRIBUTION
              </Button>
            </Col>
          )}
        </Row>
      </Col>

      {showTable && (
        <Col span={24}>
          <Form form={form} component={false} onFinish={hanldeFinish}>
            <Table
              scroll={{ x: 1200 }}
              className="special-table ims-doc-table revisions-table"
              components={{
                body: {
                  cell: (props) => (
                    <RevisionsEditableCell
                      cell={props}
                      images={images}
                      setImages={setImages}
                      attachPopupVisible={attachPopupVisible}
                      setAttachPopupVisible={setAttachPopupVisible}
                      currentUpdateObj={currentUpdateObj}
                      values={form.getFieldsValue()}
                    />
                  ),
                },
              }}
              rowKey={(record) => record.id}
              loading={fetchingLoading}
              rowClassName="editable-row"
              dataSource={data}
              columns={mergedColumns}
              onChange={handleChange}
              pagination={false}
            />
          </Form>
        </Col>
      )}
    </Row>
  );
}

export default DistributionsTable;
